import React, { createRef } from 'react';
import styled from 'styled-components';
import { element, node } from 'prop-types';

const Container = styled.div`
  position: relative;
`;

const TriggerContainer = styled.div`
  cursor: pointer;
`;

const Tip = styled.div`
  width: 220px;
  height: auto;
  position: absolute;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.32);
  padding: 20px;
  top: ${props => props.top}px;
  left: 50%;
  margin-left: -130px;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')}
`;

const Arrow = styled.div`
  width: 14px;
  height: 14px;
  position: absolute;
  background-color: #fff;
  box-shadow: 4px 5px 8px -3px rgba(0, 0, 0, 0.5);
  transform: rotate(45deg);
  left: 50%;
  bottom: -7px;
  margin-left: -7px;
`;

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.tipRef = createRef();
    this.triggerRef = createRef();

    this.state = {
      top: 0,
      visible: false,
    };
  }

  componentWillMount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      top: -(this.tipRef.current.clientHeight + 15),
    });
  }

  componentWillUnmount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick = (e) => {
    const trigger = this.triggerRef.current;
    if (trigger) {
      const visible = trigger.contains(e.target);
      this.setState({ visible });
    }
  }

  render() {
    const { children, trigger } = this.props;
    const { top, visible } = this.state;
    return (
      <Container>
        <TriggerContainer
          ref={this.triggerRef}
          onMouseOver={() => this.setState({ visible: true })}
          onFocus={() => false}
        >
          {trigger}
        </TriggerContainer>
        <Tip ref={this.tipRef} top={top} visible={visible}>
          {children}
          <Arrow />
        </Tip>
      </Container>
    );
  }
}

export default Tooltip;

Tooltip.propTypes = {
  children: node.isRequired,
  trigger: element.isRequired,
};
